const identityServerUrl = process.env.VUE_APP_IDENTITY_SERVER_URL;

export default {
    baseURL: identityServerUrl.concat('api/v1/identity/'),
    template: [
        'TOKEN_TEMPLATE',
        (data, templateFuncs) => {
            if (data.token || data.accessToken) {
                templateFuncs.setToken(data.token || data.accessToken);
                templateFuncs.setRefreshToken(data.refreshToken);
            }

            return {};
        },
    ],
    POST: {},

    '/external': {
        POST: {},
    },

    '/refresh': {
        POST: {},
    },
};
